import { cloneDeep } from 'lodash';
import { getActionDetails } from './eventActionsUtils';

export const updateEventByAction = (event, currentAction, updateData) => {
    const updatedEvent = cloneDeep(event);
    const actionIndex = updatedEvent.actions.findIndex(action => {
        const { id: actionId, type: actionType } = getActionDetails(action);
        const { id: currentActionId, type: currentActionType } = getActionDetails(currentAction);
        return actionId === currentActionId || actionType === currentActionType;
    });
    if (actionIndex === -1) {
        return event;
    }
    updatedEvent.actions[actionIndex] = {
        ...updatedEvent.actions[actionIndex],
        ...updateData,
    };
    return updatedEvent;
};
